// extracted by mini-css-extract-plugin
export default {"filterbuttons":"latest_activities_filterbuttons__7dzAx","latactdiv":"latest_activities_latactdiv__5CDMp","activitytbl":"latest_activities_activitytbl__9bkDG"};